import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import overlayFactory from 'react-bootstrap-table2-overlay'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import { securityEventTypes, passwordChangeMethods } from '../../variables/Enums'
import { dateTimeUTCFormatter } from '../Utils/Formatter'

const eventTypeLabel  = id => securityEventTypes.find(x => x.id === id)?.title  ?? id
const changeMethLabel = id => passwordChangeMethods.find(x => x.id === id)?.title ?? id

export const SecurityAuditLog = ({ data, query, totalSize, onTableChange, isLoading }) => {
    const { t } = useTranslation()

    const columns = [
        {
            dataField: 'eventDateUTC',
            text: t('security.securityAudit.columns.date'),
            formatter: val => dateTimeUTCFormatter(val),
            headerStyle: { width: '175px' },
        },
        {
            dataField: 'eventType',
            text: t('security.securityAudit.columns.event'),
            formatter: eventTypeLabel,
            headerStyle: { width: '195px' },
        },
        {
            dataField: 'userName',
            text: t('security.securityAudit.columns.user'),
        },
        {
            dataField: 'fromIP',
            text: t('security.securityAudit.columns.ip'),
            headerStyle: { width: '130px' },
        },
        {
            dataField: 'changeMethod',
            text: t('security.securityAudit.columns.changeMethod'),
            formatter: val => val != null ? changeMethLabel(val) : '—',
            headerStyle: { width: '175px' },
        },
        {
            dataField: 'actorUserName',
            text: t('security.securityAudit.columns.actorUserName'),
            headerStyle: { width: '175px' },
            formatter: val => val ?? '—',
        },
        {
            dataField: 'details',
            text: t('security.securityAudit.columns.details'),
            formatter: val => val ?? '—',
        },
    ]

    return (
        <BootstrapTable
            remote
            bordered={false}
            hover
            keyField="id"
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"
            data={data}
            columns={columns}
            noDataIndication={() => isLoading ? <span /> : <span>{t('security.securityAudit.noData')}</span>}
            pagination={paginationFactory({
                page: query.pageIndex + 1,
                sizePerPage: query.pageSize,
                totalSize,
                hideSizePerPage: true,
            })}
            onTableChange={onTableChange}
            loading={isLoading}
            overlay={overlayFactory({ spinner: true })}
        />
    )
}

SecurityAuditLog.propTypes = {
    data: PropTypes.array.isRequired,
    query: PropTypes.object.isRequired,
    totalSize: PropTypes.number.isRequired,
    onTableChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
}
